module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "c-cover"
  }, [_c('div', {
    staticClass: "c-cover__media"
  }, [_c('div', {
    staticClass: "c-cover__title-wrapper"
  }, [_c('span', {
    staticClass: "c-cover__intro"
  }, [_vm._v(_vm._s(_vm.intro))]), _vm._v(" "), _c('h1', {
    staticClass: "c-cover__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('img', {
    staticClass: "c-cover__image",
    attrs: {
      "src": _vm.content.data.cover.url,
      "alt": _vm.content.data.cover.alt,
      "width": _vm.content.data.cover.dimensions.width,
      "height": _vm.content.data.cover.dimensions.height
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "c-cover__download",
    attrs: {
      "href": _vm.content.data.pdf_download.url,
      "target": "_blank"
    }
  }, [_vm._v("Download a complete version of The Changing Lawyer here")]), _vm._v(" "), _c('a', {
    staticClass: "c-cover__link-back",
    attrs: {
      "href": "//litera.com/",
      "target": "_self"
    }
  }, [_vm._v("Visit Litera Microsystems")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d3894a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostsCover.vue
// module id = 76
// module chunks = 0